import SVGInjector from 'svg-injector';

(function () {
    // @see https://github.com/iconic/SVGInjector

    // Elements to inject
    const files = document.querySelectorAll('img[src*=".svg"]');

    // 	Options
    const injectorOptions = {
        evalScripts: 'never',
        // pngFallback: 'assets/png',
        each: function () {
            // Callback after each SVG is injected
        }
    };

    // Trigger the injection
    SVGInjector(files, injectorOptions, function () {
        // Callback after all SVGs are injected
    });

})();
